// extracted by mini-css-extract-plugin
export default {"EventInfo":"EventInfo_EventInfo__AqgNj","SiteText":"EventInfo_SiteText__kxA3j","SectionTitle":"EventInfo_SectionTitle__VDMZh"};